export default {
  SET_SHOP_LIST(state, shopListData) {
    const uniqueShopListData = shopListData.list.filter(newItem => !state.shopListData.list.some(oldItem => oldItem.id === newItem.id));
    state.shopListData.list = (shopListData.offset === 1) ? shopListData.list : state.shopListData.list.concat(uniqueShopListData);
    state.shopListData.count = shopListData.count;
  },
  SET_SHOP_DETAIL(state, shopDetail) {
    state.shopDetail = shopDetail;
  },
  SET_FAVORITE(state, params) {
    let index = state[params.key].list.findIndex((item) => item.id === params.id);
    state[params?.key]?.list?.[index] && (state[params.key].list[index].isFavorite = params?.isFavorite ?? false);
  },
  SET_PREFECTURES(state, prefectures) {
    state.prefectures = prefectures;
  },
  SET_MUNICIPALITY(state, municipalities) {
    state.municipalities = municipalities;
  },
  SET_SHOP_PREFECTURES(state, shopPrefectures) {
    state.shopPrefectures = shopPrefectures;
  },
  SET_SHOP_MUNICIPALITIES(state, shopMunicipalities) {
    state.shopMunicipalities = shopMunicipalities;
  },
  SET_GENRE(state, genres) {
    state.genres = genres;
  },
  SET_DATA_TOTAL(state, count) {
    state.count = count;
  },
  RESET_STATE(state) {
    Object.assign(state, initialState());
  },
  SET_COUPONS(state, couponsData) {
    state.couponsData = couponsData;
  },
  ADD_COUPONS(state, couponsData) {
    const uniqueCouponListData = couponsData.list.filter(newItem => !state.couponsData.list.some(oldItem => oldItem.id === newItem.id));
    state.couponsData.list = (couponsData.offset === 1) ? couponsData.list : state.couponsData.list.concat(uniqueCouponListData);
    state.couponsData.count = couponsData.count;
  },
  SET_PHOTOS(state, photosData) {
    state.photosData = photosData || {};
    photosData.categories = [{ id: 'default', name: 'すべて' }, ...(Array.isArray(photosData.categories) ? photosData.categories : [])];
  },
  SET_MENU(state, menuData) {
    menuData.categories = [{ id: 'default', name: 'すべて' }, ...menuData.categories];
    state.menuData = menuData;
  },
  ADD_MENU_LIST(state, { list }) {
    state.menuData.list = state.menuData.list.concat(list);
  },
  ADD_PHOTO_LIST(state, { list }) {
    state.photosData.list = state.photosData.list.concat(list);
  },
  SET_COUPON_DETAIL(state, couponDetail) {
    state.couponDetail = couponDetail;
  },
  SET_GALLERY_DETAIL(state, galleryDetail) {
    state.galleryDetail = galleryDetail;
  },
  REMOVE_ITEM_FAVORITE(state, params) {
    let index = state[params.key].list.findIndex((item) => item.id === params.id);
    if (index !== -1) {
      state[params.key].list.splice(index, 1);
    }
  },
  SET_IS_ERROR_COUPON_DETAIL(state, isError) {
    state.isErrorCouponDetail = isError;
  },
  SET_PARENT_SHOP_DETAIL(state, parentShopDetail) {
    state.parentShopDetail = parentShopDetail;
  },
  SET_PARENT_SHOP_ID(state, parentShopId) {
    state.parentShopId = parentShopId;
  },
  SET_NEW_POINT(state, point) {
    state.newPoint = point;
  },
  SET_BAR_CODE_QR(state, barcodeQr) {
    state.barcodeQr = barcodeQr;
  },
  SET_FAVORITE_SHOP_LIST(state, shopListData) {
    const uniqueShopListData = shopListData.list.filter(newItem => !state.favoriteShopListData.list.some(oldItem => oldItem.id === newItem.id));
    state.favoriteShopListData.list = (shopListData.offset === 1) ? shopListData.list : state.favoriteShopListData.list.concat(uniqueShopListData);
    state.favoriteShopListData.count = shopListData.count;
  },
  SET_FAVORITE_COUPONS(state, couponsData) {
    const uniqueCouponListData = couponsData.list.filter(newItem => !state.favoriteCouponsData.list.some(oldItem => oldItem.id === newItem.id));
    state.favoriteCouponsData.list = (couponsData.offset === 1) ? couponsData.list : state.favoriteCouponsData.list.concat(uniqueCouponListData);
    state.favoriteCouponsData.count = couponsData.count;
  },
  SET_FAVORITE_PHOTOS(state, photosData) {
    state.favoritePhotosData = photosData || {};
    state.favoritePhotosData.categories = [{ id: 'default', name: 'すべて' }, ...(Array.isArray(photosData.categories) ? photosData.categories : [])];
  },
  ADD_FAVORITE_PHOTO_LIST(state, { list }) {
    state.favoritePhotosData.list = state.favoritePhotosData.list.concat(list);
  },
};

export const initialState = () => ({
  shopListData: { list: [], count: 0 },
  favoriteShopListData: { list: [], count: 0 },
  shopDetail: {},
  parentShopDetail: {},
  parentShopId: null,
  isFavorite: {},
  prefectures: [],
  municipalities: [],
  shopPrefectures: [],
  shopMunicipalities: [],
  genres: [],
  couponsData: { list: [], count: 0 },
  favoriteCouponsData: { list: [], count: 0 },
  photosData: { list: [], categories: [], count: 0 },
  favoritePhotosData: { list: [], categories: [], count: 0 },
  menuData: { list: [], categories: [], count: 0 },
  couponDetail: {},
  galleryDetail: {},
  count: 0,
  isErrorCouponDetail: false,
  newPoint: 0,
  barcodeQr: '',
});
